import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import React from "react";
import CcIconButton from "../mui/CcIconButton";

/**
 * Add affordance for member/resident picker rows (unselected state).
 */
export const CcMemberPickerAddIcon = () => <AddOutlinedIcon fontSize="small" />;

/**
 * Selected affordance for member/resident picker rows.
 */
export const CcMemberPickerSelectedIcon = () => (
  <CheckRoundedIcon fontSize="small" />
);

/**
 * Standard remove control for selected member/resident rows in picker modals.
 */
export const CcMemberPickerRemoveButton = ({
  label = "Remove",
  onClick,
  disabled = false,
}) => (
  <CcIconButton
    label={label}
    size="sm"
    variant="danger"
    disabled={disabled}
    onClick={onClick}
  >
    <DeleteOutlineIcon fontSize="small" />
  </CcIconButton>
);

/**
 * Toggle icon shown on the right of a picker row.
 */
export const CcMemberPickerSelectionIcon = ({ selected = false }) =>
  selected ? <CcMemberPickerSelectedIcon /> : <CcMemberPickerAddIcon />;
